// extracted by mini-css-extract-plugin
module.exports = {"passwordBlock":"SetNewPassword_passwordBlock__Z5_nr","title":"SetNewPassword_title__axNf-","titleCreatePassword":"SetNewPassword_titleCreatePassword__2MYF6"};